import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiTrendingDown,FiDollarSign,FiShield}=FiIcons;

const HeroSection=()=> {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Video Background - Lazy loaded with low initial quality */}
      <div className="absolute inset-0 z-0">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          loading="lazy"
        >
          <source src="https://s3.us-east-2.wasabisys.com/crc-cdn/crc/internet-hero.mp4" type="video/mp4" />
        </video>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/90 via-gray-900/90 to-red-900/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 text-center">
        <motion.div
          initial={{opacity: 0,y: 50}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Lower Your Business Internet Bill in{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-blue-400">
              NYC & Hudson Valley
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-6 max-w-4xl mx-auto">
            We help NYC businesses reduce their internet costs by negotiating with Verizon, Spectrum, Comcast, Optimum, and other providers. 
            Learn how to negotiate your internet bill and discover if you're paying above the average internet bill NYC businesses face.
          </p>
          <p className="text-lg text-gray-400 mb-8 max-w-3xl mx-auto">
            Our Manhattan business internet specialists provide professional NYC business internet service consultations to help you understand your options and secure better rates.
          </p>

          <div className="flex flex-col md:flex-row gap-4 justify-center items-center mb-8">
            <div className="flex items-center gap-2 text-blue-400">
              <SafeIcon icon={FiShield} className="text-2xl" />
              <span className="text-lg">Secure & Confidential</span>
            </div>
            <div className="flex items-center gap-2 text-red-400">
              <SafeIcon icon={FiTrendingDown} className="text-2xl" />
              <span className="text-lg">Bill Analysis</span>
            </div>
            <div className="flex items-center gap-2 text-green-400">
              <SafeIcon icon={FiDollarSign} className="text-2xl" />
              <span className="text-lg">Lower Internet Bill Consultation</span>
            </div>
          </div>

          <motion.button
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            className="bg-gradient-to-r from-red-600 to-blue-600 text-white px-8 py-4 rounded-lg text-xl font-semibold hover:from-red-700 hover:to-blue-700 transition-all duration-300 shadow-lg"
            onClick={()=> document.getElementById('upload-form').scrollIntoView({behavior: 'smooth'})}
          >
            Schedule Your Free Consultation
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;